import {combineReducers} from "redux";
import salesReport from "./salesReport/store/salesReportSlice";
import backInStockRequest from "./backInStockReport/store/backInReportSlice";
import exchangeOrder from "./exchangeOrder/store/exchangeOrderSlice"
import offerItemReport from "./verifyOfferItems/store/verifyOfferItemsSlice";
import salesInvoiceReport from "./goddiva/store/salesInvoiceReportSlice";
import salesInvoiceItemReport from "./goddiva/store/salesInvoiceItemSlice";

const reportReducer = combineReducers({
    salesReport,
    backInStockRequest,
    exchangeOrder,
    offerItemReport,
    salesInvoiceReport,
    salesInvoiceItemReport
});

export default reportReducer;